import { useState, useEffect } from "react"

function useLocalStorage(key, initialValue) {
  // Initialize state with the value from localStorage or fallback to initialValue
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = localStorage.getItem(key)
      return item ? item : initialValue
    } catch (error) {
      console.error("Error reading localStorage key:", key, error)
      return initialValue
    }
  })

  // Update localStorage when state changes
  const setValue = (value) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value
      setStoredValue(valueToStore)
      localStorage.setItem(key, valueToStore)
    } catch (error) {
      console.error("Error setting localStorage key:", key, error)
    }
  }

  return [storedValue, setValue]
}

export default useLocalStorage
